import { lazy } from 'react';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';

const ClinicList = lazy(() => import('@pages/ClinicList'));
const AddClinic = lazy(() => import('@pages/AddClinic'));
const EditClinic = lazy(() => import('@pages/EditClinic'));
const SeoScript = lazy(() => import('@pages/SeoScript/index'));
const ChangePassword = lazy(() => import('@pages/ChangePassword'));

export const roles = {
  SUPER_ADMIN: 'super admin'
};

export const menu = [
  {
    icon: 'plus',
    name: 'Add Clinic',
    link: '/clinics/add',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [],
    component: <AddClinic />
  },
  {
    icon: 'clinic',
    name: 'Edit Clinic',
    link: '/clinics/:id/edit',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [],
    component: <EditClinic />
  },
  {
    icon: <LocalHospitalOutlinedIcon />,
    name: 'Clinics',
    link: '/clinics',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [roles.SUPER_ADMIN],
    component: <ClinicList />
  },
  {
    icon: <ArticleOutlinedIcon />,
    name: 'SEO Script',
    link: '/seo-script',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [roles.SUPER_ADMIN],
    component: <SeoScript />
  },
  {
    icon: 'user',
    name: 'Change Password',
    link: '/change-password',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [],
    component: <ChangePassword />
  }
];
